import React from 'react'
import View from './view'
import {selectActiveChallenge} from '../../../../redux/challenges'
import {useSelector} from 'react-redux'
import {selectMember} from '../../../../redux/members'

type Props = {
  courseId?: string
}

const ChallengeCard = ({courseId}: Props) => {
  const challenge = useSelector(selectActiveChallenge)
  const member = useSelector(selectMember)

  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const cutoffDate = challenge ? new Date(challenge?.entriesLimitDate) : today

  const isPremiumGroupMember =
    member &&
    member.accessLevel === 'premium' &&
    member.groupAccounts &&
    member.groupAccounts.length > 0

  const showCard =
    challenge &&
    !isPremiumGroupMember &&
    today <= cutoffDate &&
    !challenge.hasEntry

  return challenge ? (
    <View challenge={challenge} showCard={showCard} courseId={courseId} />
  ) : (
    <></>
  )
}

export default ChallengeCard
